import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

import AdviceSection from '../common/AdviceSection';
import SubMenuTabs from '../common/subMenuTabs/SubMenuTabs';
import SafetyRisksChart from '../common/charts/SafetyRisksChart';
import Methodology from '../common/Methodology';
import Related from '../common/Related';

import { safetyRisksTab } from '../../model/subMenuTabs';

const SafetyRisks = props => {

    let selected = '', selectedSubTab = '', secondLevel = '';

    for (let i = 0; i < safetyRisksTab.length; i++)
    {
        if (safetyRisksTab[i].url == props.tab)
        {
            selected = safetyRisksTab[i];
        }
    }

    // If the current tab has sub-tabs, set the selected one
    if (selected.subTabs != undefined)
    {
        secondLevel = selected.subTabs;
        for (let i = 0; i < secondLevel.length; i++)
        {
            if (secondLevel[i].url == props.indicator)
            {
                selectedSubTab = secondLevel[i];
            }
        }
    }

    const currentPath = '/working-conditions-preventions/safety-risks/';
    const selectedSurvey = '';

    const [selectedTab, setSelectedTab] = useState(selected);
    const [secondLevelTabs, setSecondLevelTabs] = useState(secondLevel);
    const [secondLevelSelectedTab, setSecondLevelSelectedTab] = useState(selectedSubTab);
    const [chartDimension, setChartDimension] = useState(window.innerWidth > 768 ? 'column' : 'bar');

    useEffect(() => {
        // Update the title of the page
        document.title = "Safety risks " + " - " + props.literals.L22020 + " - " + props.literals.L363;
        window.addEventListener('resize', updateDimension);

        if(selectedTab == 'operating-machine'){
            setSelectedTab('operating-machine');
		}
    }, [])

    const callbackSelectedIndicator = (callback) => {
		// This function will be called when changing the indicator for Exposure to Dangerous Substances
        for (let i = 0; i < secondLevelTabs.length; i++)
		{
			if (callback == secondLevelTabs[i].url)
			{
                setSecondLevelSelectedTab(secondLevelTabs[i]);
			}
		}
	}

    const callbackSelectedTab = (callback) => {
        for (let i = 0; i < safetyRisksTab.length; i++)
        {
            if (callback == safetyRisksTab[i].url)
            {
                setSelectedTab(safetyRisksTab[i]);
                setSecondLevelTabs(safetyRisksTab[i].subTabs);
                setSecondLevelSelectedTab(safetyRisksTab[i].subTabs[0]);
            }
        }	
	}

    const updateDimension = () => {
		if(window.innerWidth > 768){
            setChartDimension('column');
		}else{
            setChartDimension('bar');
		}
	}

    return (
        <div className="safety-risks">
            <AdviceSection literals={ props.literals } section={["working-conditions-preventions","safety-risks"]} 
                methodologyData={{section: 'working-conditions-preventions', subsection: 'Working conditions - Safety risks', indicator: 65}} />

            {/*First submenu*/}
            <div>
                <SubMenuTabs 
                    literals={ props.literals }
                    selectedTab={ selectedTab.url }
                    callbackSelectedTab={ callbackSelectedTab }
                    locationPath={ currentPath }
                    subMenuTabs={ safetyRisksTab }
                />
            </div>

            <div className="line background-main-light" />

            {/*Second submenu*/}
            <div>
                <SubMenuTabs 
                    literals={ props.literals }
                    selectedTab={ secondLevelSelectedTab.url }
                    selectedSurvey={ selectedSurvey }  
                    callbackSelectedTab={ callbackSelectedIndicator }
                    locationPath={`${currentPath}${selectedTab.url}/`}
                    subMenuTabs={ secondLevelTabs }
                />
            </div>

            <div className="line background-main-light" />

            <div className="container section--page card--grid xxs-w1 xs-w1 w1 center-text" >
                <div className="card--block--chart" >
                    <div className="chart--block with-filter" >
                        <div className="card--block--chart--wrapper" >
                            <div className="chart--wrapper" >
                                <SafetyRisksChart 
                                    literals={ props.literals }
                                    type={ chartDimension }
                                    colors={ ['#f6a400','#cbe2e3'] }
                                    chartType={ secondLevelSelectedTab.chartType }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="chart-legend">
                    { ReactHtmlParser( props.literals[`L${secondLevelSelectedTab.chartType[0].legend}`] ) }
                </div>
            </div>

            <Methodology literals={ props.literals } section={'Working conditions - Safety risks'} indicator={ secondLevelSelectedTab.chartType[0].chartIndicator } />
            <Related literals={ props.literals } section={["working-conditions-preventions", "safety-risks"]} />
        </div>
    )
}

export default SafetyRisks;
SafetyRisks.displayName = 'SafetyRisks';